module.exports = __webpack_public_path__ + "img/home_icon_chanpin_normal.0b2578e1.png";